// @flow

import ApiObject from './ApiObject';

export default class RestaurantLegalBank extends ApiObject {
  iban: string = '';

  bic: string = '';

  /**
   * String
   * See constants/TransferFrequency
   */
  transferFrequency: string = 'DAILY';

  identityDocument: string = '';

  // the amount in euros taken on each payment
  feeFixed: number = 0;

  // the percent taken on each payment
  feeVariable: number = 0;

  feeVatPercentage: number = 0.0;

  pspRestaurantId: string = null;

  acquirerWalletId: string = null;

  acquirerBankAccountId: string = null;
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/RestaurantLegalBank.js